import type { AreaCatalog } from '../area';
import type { flowErrors as en } from '../en/flowErrors';

export const flowErrors = {
  'flowErrors.means.notObject': 'Ein Bedeutungspaar muss ein Objekt sein.',
  'flowErrors.means.needsYesNo': 'Ein {attr}-Paar braucht ja oder nein.',
  'flowErrors.means.verdictValue': 'Ein Bewertungspaar muss einer dieser Werte sein: {values}.',
  'flowErrors.means.signalKey': 'Ein Zustandspaar braucht einen Katalogschlüssel.',
  'flowErrors.means.signalValue': 'Ein Zustandspaar ist gesetzt oder aufgehoben.',
  'flowErrors.means.fieldKey': 'Ein Feldpaar braucht einen Feldschlüssel.',
  'flowErrors.means.fieldScalar': 'Ein Feldpaar setzt einen einfachen Wert (Text oder Zahl).',
  'flowErrors.means.fieldEmpty': 'Ein Feldpaar braucht einen Wert (leer ist kein Wert).',
  'flowErrors.means.unknownAttr':
    'Ein Bedeutungspaar setzt Fertig, Abschluss, Aktivität, Bewertung, einen angegebenen Tag oder ein Feld, sonst nichts.',
  'flowErrors.pairName.delivered': 'Fertigstellung',
  'flowErrors.pairName.closed': 'Abschluss',
  'flowErrors.pairName.active': 'Aktiv',
  'flowErrors.pairName.verdict': 'Bewertung',

  'flowErrors.value.notString': '{what} muss Text sein.',
  'flowErrors.what.gatekeeper': 'Entscheidende der Phase „{stage}“',
  'flowErrors.what.workDescription': 'Beschreibung der Vorlage in Phase „{stage}“',
  'flowErrors.what.workCriteria': 'Abnahmekriterien der Vorlage in Phase „{stage}“',
  'flowErrors.what.workContributor': 'Zuständige der Vorlage in Phase „{stage}“',
  'flowErrors.stage.notObject': 'Eine Phase muss ein Objekt sein.',
  'flowErrors.stage.needsKey': 'Eine Phase braucht einen festen Schlüssel.',
  'flowErrors.stage.needsLabel': 'Phase „{stage}“ braucht eine Bezeichnung.',
  'flowErrors.stage.spinePhaseRetired':
    'Phase „{stage}“: spinePhase gibt es nicht mehr, die Bedeutung einer Phase sind ihre `means`-Paare (docs/FLOW_DEFINITION.md §11).',
  'flowErrors.stage.meansNotList':
    'Phase „{stage}“: Die Bedeutung muss eine Liste von Merkmalspaaren sein.',
  'flowErrors.stage.wrapped': 'Phase „{stage}“: {error}',
  'flowErrors.stage.meansTwice': 'Phase „{stage}“: Die Bedeutung nennt {attribute} zweimal.',
  'flowErrors.stage.gateMode': 'Phase „{stage}“: Die Schwelle muss offen oder durchgesetzt sein.',
  'flowErrors.stage.gateCondition':
    'Phase „{stage}“: Die Bedingungen der Schwelle müssen eine Liste von Aufgaben-IDs sein.',
  'flowErrors.stage.requiredFields':
    'Phase „{stage}“: requiredFields muss eine Liste von Feldschlüsseln sein.',
  'flowErrors.stage.workNotList':
    'Phase „{stage}“: Die Vorlagen der Schwelle müssen eine Liste sein.',
  'flowErrors.stage.workNotObject': 'Phase „{stage}“: Jede Vorlage muss ein Objekt sein.',
  'flowErrors.stage.workNeedsKey': 'Phase „{stage}“: Eine Vorlage braucht einen festen Schlüssel.',
  'flowErrors.stage.workDuplicateKey':
    'Phase „{stage}“: Der Vorlagenschlüssel „{template}“ kommt doppelt vor.',
  'flowErrors.stage.workNeedsTitle': 'Phase „{stage}“: Vorlage „{template}“ braucht einen Titel.',
  'flowErrors.stage.workMandatory':
    'Phase „{stage}“: mandatory der Vorlage „{template}“ muss ja oder nein sein.',
  'flowErrors.stage.workSeeds':
    'Phase „{stage}“: Die Startwerte einer Vorlage müssen ein Objekt sein.',
  'flowErrors.stages.notList': 'Die Phasen müssen eine Liste sein.',
  'flowErrors.stages.duplicateKey': 'Der Phasenschlüssel „{stage}“ kommt doppelt vor.',
  'flowErrors.who.notObject': 'Ein Wer muss ein Objekt sein.',
  'flowErrors.who.seatRole': 'Ein Wer über eine Rolle der Aufgabe braucht eine Rolle ({roles}).',
  'flowErrors.who.groupRole': 'Ein Wer über eine Rolle im Ablauf braucht eine Rolle ({roles}).',
  'flowErrors.who.unknownKind':
    'Ein Wer wählt eine Rolle der Aufgabe, eine Rolle im Ablauf oder alle mit Schreibzugriff, sonst nichts.',
  'flowErrors.dispatch.policiesNotObject':
    'Die Antworten einer Automatisierung müssen ein Objekt sein.',
  'flowErrors.dispatch.unknownQuestion':
    '„{question}“ ist keine Frage, auf die eine Automatisierung stoßen kann.',
  'flowErrors.dispatch.notCommand': 'Eine Automatisierung führt einen festen Befehl aus.',
  'flowErrors.dispatch.setActiveBoolean':
    'Eine SetActive-Aktion braucht `active` als ja oder nein.',
  'flowErrors.dispatch.unknownCommand':
    'Eine Automatisierung führt einen festen Befehl aus (Tender / Retract / Close / Reopen / SetActive / Accept / Dispute / Resolve).',
  'flowErrors.action.notObject': 'Eine Aktion muss ein Objekt sein.',
  'flowErrors.action.needsTagKey': 'Eine {kind}-Aktion braucht einen Katalogschlüssel.',
  'flowErrors.action.setFieldKeys': 'Eine set-field-Aktion braucht moduleKey und fieldKey.',
  'flowErrors.action.setFieldScalar':
    'Eine set-field-Aktion setzt einen einfachen Wert (Text, Zahl oder null).',
  'flowErrors.action.unknownKind':
    'Eine Aktion führt einen festen Befehl aus, setzt oder hebt einen Katalogzustand auf oder setzt ein Feld.',
  'flowErrors.action.notList': '{block} muss eine Liste von Aktionen sein.',
  'flowErrors.stage.targetRetired':
    'Ein eigenes Ziel gibt es nicht mehr: Eine Phase zieht über ihre `means`-Paare nach (docs/FLOW_DEFINITION.md §11).',
  'flowErrors.predicate.self':
    'Ein Ablauf kann nicht nach „ich“ filtern: Er prüft eine Aufgabe für niemanden im Besonderen. Nenne stattdessen die Person oder die Gruppe.',
  'flowErrors.definition.notObject': 'Eine Ablaufdefinition muss ein Objekt sein.',
  'flowErrors.definition.nameNotString': 'Der Name eines Ablaufs muss Text sein.',
  'flowErrors.factRules.notList': 'Die Regeln müssen eine Liste sein.',
  'flowErrors.factRules.twoRules': 'Zwei Regeln bewerten „{fact}“: ein Ablauf, ein Wort pro Fakt.',
  'flowErrors.factRules.twoConditionRules':
    'Zwei Regeln bewerten „{condition}“: ein Ablauf, ein Wort pro Tag oder Phase.',
  'flowErrors.factRules.unknownStage':
    'Eine Regel nennt die Phase „{stage}“, die dieser Ablauf nicht hat.',
  'flowErrors.where.stageBlock': 'Phase „{stage}“ {block}',
  'flowErrors.ref.unknownFlowField': '{where} verweist auf das unbekannte Ablauffeld „{field}“.',
  'flowErrors.ref.unknownModule': '{where} verweist auf den unbekannten Abschnitt „{module}“.',
  'flowErrors.ref.unknownField': '{where} verweist auf das unbekannte Feld „{module}.{field}“.',
  'flowErrors.ref.unknownTag': '{where} verweist auf den unbekannten Katalogschlüssel „{tag}“.',
  'flowErrors.stage.requiresUnknownField':
    'Phase „{stage}“ verlangt das unbekannte Ablauffeld „{field}“.',
  'flowErrors.means.unreachable':
    'Die Bedeutung von Phase „{stage}“ kann nie zutreffen: Kein erreichbarer Status erfüllt {means}.',
  'flowErrors.means.duplicate':
    'Die Phasen „{a}“ und „{b}“ bedeuten genau dasselbe ({means}): Zwei Wörter für einen Status können nicht beide nachziehen. Ändere eine Bedeutung oder mach eine Phase zu einem Wort ohne Paare.',
  'flowErrors.means.collision':
    'Die Phasen „{a}“ und „{b}“ können denselben Status bedeuten: Bei {example} treffen beide zu. Bedeutungen müssen sich ausschließen, damit das Nachziehen immer genau ein Ziel hat.',
  'flowErrors.policy.unreachable':
    '{where}: {command} kann nicht auf die Frage „{question}“ stoßen. Entferne diese Antwort.',

  'flowErrors.policy.cascadeSize':
    'Die Frage „cascade-size“ ist eine Ablehnung, keine Antwort beantwortet sie.',
  'flowErrors.policy.notAnAnswer':
    '„{answer}“ ist keine Antwort auf die Frage „{question}“ ({answers}).',
  'flowErrors.policy.shape':
    'Eine Antwort auf „{question}“ ist eine Antwort, „propose“ oder „skip“.',
  'flowErrors.policy.word.skip': 'überspringen',
  'flowErrors.policy.word.propose': 'vorschlagen',
  'flowErrors.policy.word.answer': 'antworten mit „{answer}“',
  'flowErrors.policy.word.none': 'keine',

  'flowErrors.factRule.notObject': '{where} muss ein Objekt sein.',
  'flowErrors.factRule.unknownFact': '{where} nennt einen unbekannten Fakt.',
  'flowErrors.factRule.unknownGrade': '{where} nennt eine unbekannte Stufe.',
  'flowErrors.factRule.wholeDays': '{where} braucht eine ganze Zahl von Tagen.',
  'flowErrors.factRule.needsWord': '{where} braucht ein Wort.',
  'flowErrors.factRule.needsTag': '{where} braucht einen Tag.',
  'flowErrors.factRule.needsStage': '{where} braucht eine Phase.',
  'flowErrors.factRule.conditionNoDays':
    '{where} nennt einen Tag oder eine Phase und nimmt keine Anzahl von Tagen.',
  'flowErrors.factRule.needsThreshold':
    '{where} bewertet eine Stille und braucht deshalb eine Zahl von Tagen: Nichts hier weiß, wie lange „{fact}“ dauern darf, bevor es zählt.',
  'flowErrors.where.factRule': 'Eine Regel',
  'flowErrors.where.boardRule': 'Eine Regel des Boards',

  'flowErrors.move.whoInto': 'Aufgaben nach „{stage}“ verschieben darf nur: {who}.',
  'flowErrors.move.whoOutOf': 'Aufgaben aus „{stage}“ verschieben darf nur: {who}.',
  'flowErrors.move.leaving': 'Zum Verlassen von „{stage}“ fehlt: {criteria}.',
  'flowErrors.move.leavingOneOf': 'Zum Verlassen von „{stage}“ fehlt eines davon: {criteria}.',
  'flowErrors.move.entering': 'Für „{stage}“ fehlt: {criteria}.',
  'flowErrors.move.enteringOneOf': 'Für „{stage}“ fehlt eines davon: {criteria}.',
  'flowErrors.move.notAvailable': 'Nicht verfügbar.',
  'flowErrors.move.notAllowed': 'Diese Verschiebung ist nicht erlaubt.',
  'flowErrors.who.anyone': 'wer Schreibzugriff hat',
  'flowErrors.who.requester': 'die Verantwortlichen dieser Aufgabe',
  'flowErrors.who.contributor': 'die Zuständigen dieser Aufgabe',
  'flowErrors.who.owner': 'die Verwaltenden dieses Ablaufs',
  'flowErrors.who.member': 'die Mitglieder dieses Ablaufs',
  'flowErrors.criterion.joined': '{first}, {second}',
  'flowErrors.criterion.or': '{first} oder {second}',
  'flowErrors.criterion.not': 'nicht {criterion}',
  'flowErrors.criterion.delivered': 'in Review oder fertig',
  'flowErrors.criterion.notDelivered': 'offen oder abgebrochen',
  'flowErrors.criterion.noVerdict': 'noch keine Bewertung',
  'flowErrors.criterion.accepted': 'abgenommen',
  'flowErrors.criterion.disputed': 'Abnahme verweigert',
  'flowErrors.criterion.cancelled': 'abgebrochen',
  'flowErrors.criterion.notCancelled': 'nicht abgebrochen',
  'flowErrors.criterion.done': 'fertig',
  'flowErrors.criterion.notDone': 'nicht fertig',
  'flowErrors.criterion.requesterSeated': 'Verantwortliche eingetragen',
  'flowErrors.criterion.contributorSeated': 'Zuständige eingetragen',
  'flowErrors.criterion.noRequesterSeated': 'keine Verantwortlichen eingetragen',
  'flowErrors.criterion.noContributorSeated': 'keine Zuständigen eingetragen',
  'flowErrors.criterion.requesterIs': 'Verantwortlich: {ref}',
  'flowErrors.criterion.contributorIs': 'Zuständig: {ref}',
  'flowErrors.criterion.requesterIsNot': 'Verantwortlich: nicht {ref}',
  'flowErrors.criterion.contributorIsNot': 'Zuständig: nicht {ref}',
  'flowErrors.criterion.wearing': 'trägt „{signal}“',
  'flowErrors.criterion.tagged': 'mit Tag {tags}',
  'flowErrors.criterion.notTagged': 'nicht mit Tag {tags}',
  'flowErrors.criterion.tagValue': '#{tag}',
  'flowErrors.criterion.untagged': 'ohne Tag',
  'flowErrors.criterion.hasTag': 'mit einem Tag',
  'flowErrors.criterion.fieldEmpty': 'Feld „{field}“ leer',
  'flowErrors.criterion.fieldIs': 'Feld „{field}“ = {value}',
  'flowErrors.criterion.closed': 'fertig oder abgebrochen',
  'flowErrors.criterion.notClosed': 'offen oder in Review',
  'flowErrors.criterion.active': 'aktiv',
  'flowErrors.criterion.notActive': 'nicht aktiv',
  'flowErrors.criterion.levelAtLeast': 'Zustand mindestens {level}',
  'flowErrors.criterion.levelBelow': 'Zustand unter {level}',
  'flowErrors.criterion.unclaimed': 'noch zu vergeben',
  'flowErrors.criterion.assignedTo': 'zugeordnet an {ref}',
  'flowErrors.criterion.notAssignedTo': 'nicht zugeordnet an {ref}',
  'flowErrors.criterion.partiesInclude': 'Beteiligte: {ref}',
  'flowErrors.criterion.partiesExclude': 'Beteiligte: nicht {ref}',
  'flowErrors.criterion.noParties': 'keine Beteiligten',
  'flowErrors.criterion.hasParties': 'mit Beteiligten',
  'flowErrors.criterion.inGroup': 'in Gruppe {group}',
  'flowErrors.criterion.notInGroup': 'nicht in Gruppe {group}',
  'flowErrors.criterion.noGroup': 'in keiner Gruppe',
  'flowErrors.criterion.inAGroup': 'in einer Gruppe',
  'flowErrors.criterion.childOf': 'direkt unter {parent}',
  'flowErrors.criterion.notChildOf': 'nicht direkt unter {parent}',
  'flowErrors.criterion.under': 'unter {parent}',
  'flowErrors.criterion.notUnder': 'nicht unter {parent}',
  'flowErrors.criterion.noParent': 'ohne übergeordnete Aufgabe',
  'flowErrors.criterion.hasParent': 'mit übergeordneter Aufgabe',
  'flowErrors.criterion.titleContains': 'Titel enthält „{text}“',
  'flowErrors.criterion.titleLacks': 'Titel enthält nicht „{text}“',
  'flowErrors.level.info': 'Info',
  'flowErrors.level.notice': 'Hinweis',
  'flowErrors.level.warning': 'Warnung',
  'flowErrors.level.critical': 'kritisch',
  'flowErrors.owner.personal': 'Persönlich',
  'flowErrors.owner.shared': 'Geteilter Ablauf',
  'flowErrors.owner.group': 'eine Gruppe',
  'flowErrors.flow.notFound':
    'Ablauf nicht gefunden (oder nicht mehr aktiv) in dieser Organisation.',
  'flowErrors.flow.alreadyMember': 'Die Aufgabe ist schon in diesem Ablauf (in „{stage}“).',
  'flowErrors.flow.noStage': 'In diesem Ablauf gibt es keine Phase „{stage}“.',
  'flowErrors.flow.noStageFieldsOnly':
    'Dieser Ablauf hat nur Felder, eine Phase „{stage}“ gibt es nicht.',
  'flowErrors.flow.notMember': 'Die Aufgabe ist nicht in diesem Ablauf.',
  'flowErrors.flow.notMemberOfThat': 'Diese Aufgabe ist nicht in diesem Ablauf.',
  'flowErrors.flow.currentStageGone':
    'Die aktuelle Phase „{stage}“ gibt es in diesem Ablauf nicht mehr.',
  'flowErrors.flow.alreadyAtStage': 'Die Aufgabe ist schon in dieser Phase.',
  'flowErrors.flow.storedUnparsable':
    'Die gespeicherte Definition dieses Ablaufs lässt sich nicht mehr lesen: {error}',
  'flowErrors.flow.ownerOnly': 'Nur Verwaltende des Ablaufs dürfen {verb}.',
  'flowErrors.gate.enforcedNeedsGatekeeper':
    'Die Schwelle zu „{stage}“ wird durchgesetzt: Vorrücken darüber hinaus braucht die Entscheidenden.',
  'flowErrors.gate.enforcedUnmet':
    'Die Schwelle zu „{stage}“ wird durchgesetzt und ihre Bedingungen sind nicht erfüllt: Erst muss die Schwelle passieren.',
  'flowErrors.hold.positionGone':
    'Die aktuelle Position „{stage}“ gibt es in diesem Ablauf nicht mehr.',
  'flowErrors.hold.lastStage': 'Das ist die letzte Phase, es gibt keine Schwelle zum Anhalten.',
  'flowErrors.hold.needsGatekeeper':
    'Anhalten in „{stage}“ braucht die Entscheidenden oder Verwaltende der Aufgabe.',
  'flowErrors.waive.needsGatekeeper':
    'Eine Bedingung der Schwelle zu „{stage}“ erlassen braucht die Entscheidenden oder Verwaltende der Aufgabe.',
  'flowErrors.waive.notACondition':
    'Dieser Verweis ist keine Bedingung dieser Schwelle für diese Aufgabe.',
  'flowErrors.waive.already': 'Schon erlassen.',
  'flowErrors.gateWork.needsTitle': 'Eine Aufgabe an der Schwelle braucht einen Titel.',
  'flowErrors.seeds.unknownModule':
    'Die Startwerte der Vorlage nennen den unbekannten Abschnitt „{module}“.',
  'flowErrors.seeds.notObject': 'Die Startwerte der Vorlage für „{module}“ müssen ein Objekt sein.',
  'flowErrors.join.sharedNeedsOwner':
    'Wer eine Aufgabe in einen geteilten Ablauf aufnimmt, teilt sie mit dessen Personenkreis: Das braucht Verwaltende der Aufgabe (Verwaltende oder Verantwortliche).',
  'flowErrors.join.viewMemberOnly':
    'Nur Mitglieder dieses Boards dürfen seine Aufgaben in einen Ablauf aufnehmen.',

  'flowErrors.field.notObject': 'Eine Felddefinition muss ein Objekt sein.',
  'flowErrors.field.needsKey': 'Ein Feld braucht einen festen Schlüssel.',
  'flowErrors.field.needsName': 'Feld „{field}“ braucht einen Namen.',
  'flowErrors.field.needsDescription':
    'Feld „{field}“ braucht eine Beschreibung: Sag, was es bedeutet, nicht nur, was es speichert.',
  'flowErrors.field.unknownType': 'Feld „{field}“: unbekannter Typ.',
  'flowErrors.field.selectionNeedsValue':
    'Feld „{field}“: Eine Auswahl braucht mindestens einen Wert.',
  'flowErrors.field.emptyValue': 'Feld „{field}“: leerer Wert.',
  'flowErrors.field.duplicateValue': 'Feld „{field}“: Der Wert „{value}“ kommt doppelt vor.',
  'flowErrors.field.valuesOnSelection': 'Feld „{field}“: Nur eine Auswahl hat Werte.',
  'flowErrors.field.variantOnText': 'Feld „{field}“: Nur Textfelder haben eine Variante.',
  'flowErrors.field.unknownVariant': 'Feld „{field}“: unbekannte Textvariante.',
  'flowErrors.field.cardinalityOnSelection':
    'Feld „{field}“: Nur Auswahl- und Personenfelder haben eine Anzahl.',
  'flowErrors.field.unknownCardinality': 'Feld „{field}“: unbekannte Anzahl.',
  'flowErrors.fields.notList': 'Die Felder müssen eine Liste sein.',
  'flowErrors.fields.duplicateKey': 'Der Feldschlüssel „{field}“ kommt doppelt vor.',
  'flowErrors.definition.payloadNotObject': 'Die Daten eines Ablaufs müssen ein Objekt sein.',

  'flowErrors.definition.badAnchor':
    'Eine Definition gehört zu einer Gruppe, einer Person oder einer Aufgabe: {ref}',
  'flowErrors.definition.personalNeedsOrg':
    'Nur Mitglieder einer Organisation können einen persönlichen Bereich gestalten.',
  'flowErrors.definition.ownPersonalOnly': 'Du kannst nur in deinem eigenen Bereich {verb}.',
  'flowErrors.definition.anchorGroupNotFound': 'Die Gruppe der Definition wurde nicht gefunden.',
  'flowErrors.definition.endeavorOwnerOnly':
    'Nur Verwaltende des Vorhabens dürfen für seinen Ablauf {verb}.',
  'flowErrors.definition.notFound': 'Definition nicht gefunden.',
  'flowErrors.definition.alreadyArchived': 'Schon archiviert.',
  'flowErrors.definition.notArchived': 'Nicht archiviert.',
  'flowErrors.definition.needsName': 'Ein Ablauf braucht einen Namen.',
  'flowErrors.definition.keyTaken': 'Einen Ablauf „{key}“ gibt es hier schon.',
  'flowErrors.definition.notAFlow': 'Das ist keine Ablaufdefinition.',
  'flowErrors.definition.unchanged': 'Der Ablauf ist unverändert.',
  'flowErrors.verb.archive': 'ihn archivieren',
  'flowErrors.verb.unarchive': 'ihn wiederherstellen',
  'flowErrors.verb.defineFlow': 'einen Ablauf anlegen',
  'flowErrors.verb.change': 'ihn ändern',
  'flowErrors.verb.changeAccess': 'seinen Zugriff ändern',
  'flowErrors.verb.setCeremonyRole': 'eine Rolle in der Besprechung vergeben',
  'flowErrors.verb.closeCeremony': 'eine Besprechung abschließen',
  'flowErrors.cycle.definite':
    'Diese Definition schließt eine Schleife von Automatisierungen, die in jedem Status auslöst: {steps} -> (zurück zum Anfang). Eine Regel, die ihren eigenen Auslöser erzeugt, ist eine verkehrt geschriebene Schwelle: Drück „darf nicht“ als Bedingung beim Betreten oder als Bewertung aus, nie als Rückgängigmachen.',
  'flowErrors.cycle.potential':
    'Mit einer MÖGLICHEN Schleife von Automatisierungen gespeichert (sie schließt sich nur unter Bedingungen): {steps} -> (zurück zum Anfang). Falls sie je auslöst, fangen die Schutzregeln zur Laufzeit sie ab (no-undo, no-revisit, das Schrittbudget).',

  'flowErrors.decision.advanceNeeds':
    'Eine Entscheidung zum Vorrücken braucht einen Ablauf und eine Zielphase.',
  'flowErrors.decision.holdNeeds': 'Eine Entscheidung zum Anhalten braucht einen Ablauf.',
  'flowErrors.decision.unknownOutcome': 'Unbekanntes Ergebnis einer Entscheidung: „{outcome}“.',
  'flowErrors.ceremony.notFound': 'Besprechung nicht gefunden.',
  'flowErrors.ceremony.partyOnly':
    'Nur wer die Besprechung einberufen hat oder auf der Teilnahmeliste steht, darf {verb}.',
  'flowErrors.ceremony.needsTitle': 'Eine Besprechung braucht einen Titel.',
  'flowErrors.ceremony.closed': 'Diese Besprechung ist abgeschlossen.',
  'flowErrors.ceremony.alreadyClosed': 'Diese Besprechung ist schon abgeschlossen.',
  'flowErrors.ceremony.agendaItemNotFound': 'Punkt der Tagesordnung nicht gefunden.',
  'flowErrors.ceremony.alreadyApplied': 'Diese Entscheidung wurde schon umgesetzt.',
  'flowErrors.ceremony.alreadyDeclined': 'Diese Entscheidung wurde schon verworfen.',

  'flowErrors.finding.flowNotFound': 'Ablaufdefinition nicht gefunden.',
  'flowErrors.finding.flowsOnly': 'Befunde gehören nur zu Ablaufdefinitionen.',
  'flowErrors.finding.actionRefused': 'Aktion {action} wurde beim Ausführen abgewiesen: {error}',
  'flowErrors.finding.actionRefusedOnQuestion':
    'Aktion {action} wurde beim Ausführen an der Frage „{question}“ abgewiesen (Antwort: {policy}): {error}',
  'flowErrors.finding.cameBackOnLane':
    'Aktion {action} kam beim Ausführen über den Weg {lane} zurück, den eine Automatisierung nicht beantworten kann. Nichts wurde getan.',
  'flowErrors.finding.cameBackWithQuestion':
    'Aktion {action} kam beim Ausführen mit einer Frage zurück, die eine Automatisierung nicht beantworten kann. Nichts wurde getan.',
  'flowErrors.finding.pullRefused': 'Das Nachziehen nach „{stage}“ wurde abgewiesen: {error}',
  'flowErrors.finding.couldNotCall': 'Eine Aufgabe ließ sich nicht „{word}“ nennen: {error}',
  'flowErrors.guard.noUndo':
    'Diese Regel würde {target} auf den Wert zurücksetzen, der direkt vor der auslösenden Handlung galt: Sie macht ihren eigenen Auslöser rückgängig. Eine solche Regel ist eine verkehrt geschriebene Schwelle: Drück „darf nicht“ als Bedingung beim Betreten (vor der Handlung) oder als verweigerte Abnahme (danach) aus, nie als Rückgängigmachen.',
  'flowErrors.guard.noRevisit':
    'Diese Kette hat {target} schon einmal auf genau diesen Wert gesetzt. Ein zweites Mal hieße, die Regeln drehen sich im Kreis, deshalb hält die Kette hier an. Prüfe die Abläufe dieser Aufgabe auf Regeln, die gegenseitig ihre Auslöser erzeugen.',
  'flowErrors.guard.hopBudget':
    'Diese Handlung wäre der {hop}. maschinelle Schritt in Folge nach einer einzigen Handlung, die Grenze ist {limit}. Regeln, die so tief reichen, drehen sich fast sicher durch dieselben Status: Vereinfache die Kette oder lass eine Person handeln.',
  'flowErrors.target.atom': 'den Status „{target}“',
  'flowErrors.target.verdict': 'die Bewertung',
  'flowErrors.target.tag': 'den Zustand „{tag}“',
  'flowErrors.target.field': 'das Feld „{field}“',
  'flowErrors.target.position': 'die Position in der Phase',
  'flowErrors.target.other': '„{target}“',
} as const satisfies AreaCatalog<typeof en>;
